export { default } from './zh-Hant';
